import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPaperPlane, faUser, faGift } from '@fortawesome/pro-light-svg-icons';
import { useTranslation, Trans } from 'react-i18next';

const Program = () => {
  const { t } = useTranslation('affiliatesModule');
  return (
    <div className="flex flex-col items-center w-full border-b border-card-border pb-8 pt-4 mb-8">
      <h2 className="text-2xl font-semibold mb-2 text-center">
        {t('program.title')}
      </h2>
      <p className="text-base mb-10 text-center max-w-xl">
        {t('program.subtitle')}
      </p>
      <div className="flex flex-col md:flex-row justify-center items-center gap-4 w-full">
        <div className="flex flex-col items-center text-center">
          <FontAwesomeIcon
            icon={faPaperPlane}
            className="text-primary text-xl mb-3"
          />
          <span className="text-sm max-w-[184px]">{t('program.step1')}</span>
        </div>
        <div className="w-20 h-px bg-card-border my-4 mx-0 hidden md:block" />
        <div className="flex flex-col items-center text-center">
          <FontAwesomeIcon
            icon={faUser}
            className="text-primary text-xl mb-3"
          />
          <span className="text-sm max-w-[184px]">{t('program.step2')}</span>
        </div>
        <div className="w-20 h-px bg-card-border my-4 mx-0 hidden md:block" />
        <div className="flex flex-col items-center text-center">
          <FontAwesomeIcon
            icon={faGift}
            className="text-primary text-xl mb-3"
          />
          <span className="text-sm max-w-[184px]">
            <Trans
              i18nKey="program.step3"
              t={t}
              components={{ 1: <span className="font-bold" /> }}
            />
          </span>
        </div>
      </div>
    </div>
  );
};

export default Program;
